// The right-angle triangle from the Edge226 logo, on a 48×48 box.
export const LOADING_BOX = 48
export const TRIANGLE_PATH = 'M9 9H39V39Z'
